<template>
  <div>
    <div class="intro-y flex items-center mt-2">
      <h2 class="text-lg font-medium mr-auto">Kapan Report</h2>
    </div>
    <div class="intro-y box p-5 mt-3" style="z-index: 50;">

      <div class="grid grid-cols-12 gap-x-2">
        <div class="col-span-8 sm:col-span-6 md:col-span-6 xl:col-span-6">
          <div>
            <TomSelect v-model="page_data.kapan_id" :options="{
              placeholder: 'Select Kapan',
              loadingClass: 'loading',
              plugins: {
                dropdown_header: {
                  title: 'Kapan'
                }
              }
            }" class="w-full">
              <option v-for="item in page_data.lot_items" :key="item.id" :value="item.id">{{ item.lot_no }} (
                {{ item.voucher_no ? item.voucher_no : '-' }} )</option>
            </TomSelect>
          </div>
        </div>
        <div class="col-span-2 md:col-span-2 xl:col-span-1">

          <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full ml-2" tabindex="5"
            :disabled="page_data.r_loading == true" @click="getReportDetails()">
            Generate
          </button>
        </div>
        <div class="col-span-2 md:col-span-2 xl:col-span-1">
                <div class="flex">

                    <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full ml-2" tabindex="5" @click="exportReportDetails">
                        Export
                    </button>
                </div>
            </div>
      </div>

      <div class="mt-5">

        <div id="responsive-table" class="p-5" v-if="page_data.r_loading">
          <div class="preview">
            <div class="overflow-x-auto">
              <div class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center">
                <LoadingIcon icon="bars" class="w-8 h-8" />
                <div class="text-center text-xs mt-2">Getting Latest Price</div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div v-if="page_data.generate == 'gen'">


            <div class="intro-y box">
              <div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5">
                <h2 class="font-medium text-base mr-auto">Kapan Planning Prediction</h2>
              </div>
              <div class="p-5 border-b border-gray-200 dark:border-dark-5">
                <div class="grid grid-cols-12 gap-x-5">
                  <div class="col-span-12 lg:col-span-5">

                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Kapan No. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.kapan_details.voucher_no}} ({{page_data.kapan_details.lot_no}})
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.voucher_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Purchase Pieces. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.kapan_details.pieces}}
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Purchase Weight (Ct). :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.kapan_details.total_weight}} Ct
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Purchase Per / Ct. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.kapan_details.per_ct_rate ? page_data.kapan_details.per_ct_rate : 0}} $
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">RP Polish (Ct). :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.plan_polish_weight ? page_data.plan_polish_weight : 0}} Ct ({{ page_data.plan_polish_per ? page_data.plan_polish_per : 0 }} %)
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Plans (Ct). :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.planning_polish_pending_total.polish_weight ? page_data.planning_polish_pending_total.polish_weight : 0}} Ct ({{ page_data.planning_polish_pending_total.plan_polish_per ? page_data.planning_polish_pending_total.plan_polish_per : 0 }} %)
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Final Polish (Ct). :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.final_polish_done_total.polish_weight ? page_data.final_polish_done_total.polish_weight : 0}} Ct ({{ page_data.final_polish_done_total.plan_polish_per ? page_data.final_polish_done_total.plan_polish_per : 0 }} %)
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Polish (Ct). :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label">
                        {{page_data.final_polish_pending_total.polish_weight ? page_data.final_polish_pending_total.polish_weight : 0}} Ct ({{ page_data.final_polish_pending_total.plan_polish_per ? page_data.final_polish_pending_total.plan_polish_per : 0 }} %)
                        <!-- <span v-for="(item, key) in page_data.kapan_details" :key="key">

                          <span v-if="key != 0">, </span>{{ item.lot_no }}
                        </span> -->
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Average Weight (Ct).
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label"> <span
                          class="flex items-center">$ <input id="pos-form-1" v-model="page_data.conversation_rate"
                            name="conversation_rate" type="text" class="form-control flex-1 p-1 m-0 mx-2"
                            placeholder="Rate ($)" @input="updateInrRates" @keypress="$h.preventInvalidInput" /></span>
                      </label>
                    </div>
                    <div class="mt-2">
                      <label for="update-profile-form-6" class="form-label font-bold">Costing Per / Ct.
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label">{{
                          $h.myFloat((parseFloat(page_data.conversation_rate * (page_data.kapan_details.per_ct_rate ? page_data.kapan_details.per_ct_rate : 0)) + parseFloat(page_data.total_majuri)) / page_data.kapan_details.total_weight) }}</label>
                    </div>

                  </div>
                  <div class="col-span-12 lg:col-span-5">

                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Plan Pieces. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label"> {{ page_data.planning_polish_pending_total.total_pieces }}</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Plan Weight (Ct).
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label"> {{
                          page_data.planning_polish_pending_total.polish_weight ? page_data.planning_polish_pending_total.polish_weight : 0}} Ct</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Rough Pieces. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label"> {{ page_data.rough_polish_pending_total.total_pieces }}</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Rough Weight (Ct).
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label"> {{
                          page_data.rough_polish_pending_total.rough_weight ? page_data.rough_polish_pending_total.rough_weight : 0}} Ct</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Polish Pieces. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label"> {{ page_data.final_polish_pending_total.total_pieces }}</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Pending Polish Weight (Ct).
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label"> {{
                          page_data.final_polish_pending_total.polish_weight ? page_data.final_polish_pending_total.polish_weight : 0}} Ct</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Final Polish Pieces. :&nbsp;</label><label
                        for="update-profile-form-6" class="form-label"> {{ page_data.final_polish_done_total.total_pieces }}</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Final Polish Weight (Ct).
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label">{{
                          page_data.final_polish_done_total.polish_weight ? page_data.final_polish_done_total.polish_weight : 0}} Ct</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Total Labour.
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label">{{
                          page_data.total_majuri ? page_data.total_majuri : 0}}</label>
                    </div>
                    <div class="mt-2 cursor-pointer">
                      <label for="update-profile-form-6" class="form-label font-bold">Total Loss.
                        :&nbsp;</label><label for="update-profile-form-6" class="form-label">{{
                          page_data.total_loss ? page_data.total_loss : 0}}</label>
                    </div>

                  </div>

                </div>
              </div>
              <div class="p-5 border-b border-gray-200 dark:border-dark-5">
                <div class="">
                  <div class="border">
                    <div class="overflow-x-auto">
                      <table class="w-full text-center text-xs">
                        <thead>
                          <tr  class="dark:bg-dark-1 bg-dark-1 text-white">
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">NO</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">SIZE</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">POINTER</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PIECES</th>
                            <!-- <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Rough Weight</th> -->
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">POLISH WEIGHT(CT)
                            </th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">POLISH (%)</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Repo($)</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MFG PER/CT($)
                            </th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">AMOUNT ($)
                            </th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Repo(INR)
                            </th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MFG PER/CT(INR)
                              AVG</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">AMOUNT (INR)
                            </th>
                          </tr>
                        </thead>
                        <tbody>

                          <tr class="bg-gray-200">
                            <th class="border-b border-r py-2 px-2 whitespace-nowrap bg-gray-300 text-red" colspan="12">Final Polish</th>
                          </tr>
                          <tr class="bg-gray-200">
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" colspan="3" @click="get_plan_list(page_data.final_polish_done_total, 1)">Total</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(page_data.final_polish_done_total, 1)">{{ page_data.final_polish_done_total.total_pieces ? page_data.final_polish_done_total.total_pieces : "-" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_done_total.polish_weight ? $h.myFloat(page_data.final_polish_done_total.polish_weight) : "0" }} Ct</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_done_total.plan_polish_per ? $h.myFloat(page_data.final_polish_done_total.plan_polish_per) : "0" }} %</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_done_total.avg_repo ? $h.myFloat(page_data.final_polish_done_total.avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_done_total.avg_value ? $h.myFloat(page_data.final_polish_done_total.avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_done_total.total_value ? $h.myFloat(page_data.final_polish_done_total.total_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_done_total.inr_avg_repo ? $h.myFloat(page_data.final_polish_done_total.inr_avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_done_total.inr_avg_value ? $h.myFloat(page_data.final_polish_done_total.inr_avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_done_total.inr_total_value ? $h.myFloat(page_data.final_polish_done_total.inr_total_value) : "0" }}</th>
                          </tr>
                          <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.final_polish_done" :key="index">
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 1)">{{ sub_field.charni_name ? sub_field.charni_name : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 1)">{{ sub_field.charni_code ? sub_field.charni_code : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_pieces ? sub_field.total_pieces : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.polish_weight ? $h.myFloat(sub_field.polish_weight) : "0" }} Ct</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.plan_polish_per ? $h.myFloat(sub_field.plan_polish_per) : "0" }} %</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_repo ? $h.myFloat(sub_field.avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_value ? $h.myFloat(sub_field.avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value ? $h.myFloat(sub_field.total_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_repo ? $h.myFloat(sub_field.inr_avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_value ? $h.myFloat(sub_field.inr_avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_total_value ? $h.myFloat(sub_field.inr_total_value) : "0" }}</td>
                          </tr>
                          <tr class="bg-gray-200">
                            <th class="border-b border-r py-2 px-2 whitespace-nowrap bg-gray-300 text-red" colspan="12">Makeable Polish Pending</th>
                          </tr>
                          <tr class="bg-gray-200">
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" colspan="3" @click="get_plan_list(page_data.final_polish_pending_total, 2)">Total</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(page_data.final_polish_done_total, 2)">{{ page_data.final_polish_pending_total.total_pieces ? page_data.final_polish_pending_total.total_pieces : "-" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_pending_total.polish_weight ? $h.myFloat(page_data.final_polish_pending_total.polish_weight) : "0" }} Ct</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_pending_total.plan_polish_per ? $h.myFloat(page_data.final_polish_pending_total.plan_polish_per) : "0" }} %</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_pending_total.avg_repo ? $h.myFloat(page_data.final_polish_pending_total.avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_pending_total.avg_value ? $h.myFloat(page_data.final_polish_pending_total.avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_pending_total.total_value ? $h.myFloat(page_data.final_polish_pending_total.total_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_pending_total.inr_avg_repo ? $h.myFloat(page_data.final_polish_pending_total.inr_avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_pending_total.inr_avg_value ? $h.myFloat(page_data.final_polish_pending_total.inr_avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_pending_total.inr_total_value ? $h.myFloat(page_data.final_polish_pending_total.inr_total_value) : "0" }}</th>
                          </tr>
                          <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.final_polish_pending" :key="index">
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 2)">{{ sub_field.charni_name ? sub_field.charni_name : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 2)">{{ sub_field.charni_code ? sub_field.charni_code : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_pieces ? sub_field.total_pieces : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.polish_weight ? $h.myFloat(sub_field.polish_weight) : "0" }} Ct</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.plan_polish_per ? $h.myFloat(sub_field.plan_polish_per) : "0" }} %</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_repo ? $h.myFloat(sub_field.avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_value ? $h.myFloat(sub_field.avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value ? $h.myFloat(sub_field.total_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_repo ? $h.myFloat(sub_field.inr_avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_value ? $h.myFloat(sub_field.inr_avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_total_value ? $h.myFloat(sub_field.inr_total_value) : "0" }}</td>
                          </tr>
                          <tr class="bg-gray-200">
                            <th class="border-b border-r py-2 px-2 whitespace-nowrap bg-gray-300 text-red" colspan="12">Rough Polish Pending</th>
                          </tr>
                          <tr class="bg-gray-200">
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" colspan="3" @click="get_plan_list(page_data.rough_polish_pending_total, 3)">Total</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(page_data.final_polish_done_total, 3)">{{ page_data.rough_polish_pending_total.total_pieces ? page_data.rough_polish_pending_total.total_pieces : "-" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.rough_polish_pending_total.rough_weight ? $h.myFloat(page_data.rough_polish_pending_total.rough_weight) : "0" }} Ct</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.rough_polish_pending_total.plan_polish_per ? $h.myFloat(page_data.rough_polish_pending_total.plan_polish_per) : "0" }} %</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.rough_polish_pending_total.avg_repo ? $h.myFloat(page_data.rough_polish_pending_total.avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.rough_polish_pending_total.avg_value ? $h.myFloat(page_data.rough_polish_pending_total.avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.rough_polish_pending_total.total_value ? $h.myFloat(page_data.rough_polish_pending_total.total_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.rough_polish_pending_total.inr_avg_repo ? $h.myFloat(page_data.rough_polish_pending_total.inr_avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.rough_polish_pending_total.inr_avg_value ? $h.myFloat(page_data.rough_polish_pending_total.inr_avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.rough_polish_pending_total.inr_total_value ? $h.myFloat(page_data.rough_polish_pending_total.inr_total_value) : "0" }}</th>
                          </tr>
                          <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.rough_polish_pending" :key="index">
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 3)">{{ sub_field.charni_name ? sub_field.charni_name : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 3)">{{ sub_field.charni_code ? sub_field.charni_code : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_pieces ? sub_field.total_pieces : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.rough_weight ? $h.myFloat(sub_field.rough_weight) : "0" }} Ct</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.plan_polish_per ? $h.myFloat(sub_field.plan_polish_per) : "0" }} %</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_repo ? $h.myFloat(sub_field.avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_value ? $h.myFloat(sub_field.avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value ? $h.myFloat(sub_field.total_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_repo ? $h.myFloat(sub_field.inr_avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_value ? $h.myFloat(sub_field.inr_avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_total_value ? $h.myFloat(sub_field.inr_total_value) : "0" }}</td>
                          </tr>
                          <tr class="bg-gray-200">
                            <th class="border-b border-r py-2 px-2 whitespace-nowrap bg-gray-300 text-red" colspan="12">Planning Polish Pending</th>
                          </tr>
                          <tr class="bg-gray-200">
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" colspan="3" @click="get_plan_list(page_data.planning_polish_pending_total, 4)">Total</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(page_data.final_polish_done_total, 4)">{{ page_data.planning_polish_pending_total.total_pieces ? page_data.planning_polish_pending_total.total_pieces : "-" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.planning_polish_pending_total.polish_weight ? $h.myFloat(page_data.planning_polish_pending_total.polish_weight) : "0" }} Ct</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.planning_polish_pending_total.plan_polish_per ? $h.myFloat(page_data.planning_polish_pending_total.plan_polish_per) : "0" }} %</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.planning_polish_pending_total.avg_repo ? $h.myFloat(page_data.planning_polish_pending_total.avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.planning_polish_pending_total.avg_value ? $h.myFloat(page_data.planning_polish_pending_total.avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.planning_polish_pending_total.total_value ? $h.myFloat(page_data.planning_polish_pending_total.total_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.planning_polish_pending_total.inr_avg_repo ? $h.myFloat(page_data.planning_polish_pending_total.inr_avg_repo) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.planning_polish_pending_total.inr_avg_value ? $h.myFloat(page_data.planning_polish_pending_total.inr_avg_value) : "0" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.planning_polish_pending_total.inr_total_value ? $h.myFloat(page_data.planning_polish_pending_total.inr_total_value) : "0" }}</th>
                          </tr>
                          <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.planning_polish_pending" :key="index">
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 4)">{{ sub_field.charni_name ? sub_field.charni_name : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer" @click="get_plan_list(sub_field, 4)">{{ sub_field.charni_code ? sub_field.charni_code : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_pieces ? sub_field.total_pieces : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.polish_weight ? $h.myFloat(sub_field.polish_weight) : "0" }} Ct</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.plan_polish_per ? $h.myFloat(sub_field.plan_polish_per) : "0" }} %</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_repo ? $h.myFloat(sub_field.avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.avg_value ? $h.myFloat(sub_field.avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value ? $h.myFloat(sub_field.total_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_repo ? $h.myFloat(sub_field.inr_avg_repo) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_avg_value ? $h.myFloat(sub_field.inr_avg_value) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.inr_total_value ? $h.myFloat(sub_field.inr_total_value) : "0" }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
              <div class="p-5 border-b border-gray-200 dark:border-dark-5">
                <div class="">
                  <div class="border">
                    <div class="overflow-x-auto">
                      <table class="w-full text-center text-xs">
                        <thead>
                          <tr  class="dark:bg-dark-1 bg-dark-1 text-white">
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">NO</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PROCESS</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">TOTAL PACKERS</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">ISSUE PACKERS</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">ISSUE WEIGHT (Ct)</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">RECEIVE WEIGHT (Ct)</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">LOSS WEIGHT (Ct)</th>
                            <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">TOTAL MAJURI (Rs)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="bg-gray-200">
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap">Total</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.total_loss ? page_data.total_loss : "-" }}</th>
                              <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.total_majuri ? page_data.total_majuri : "-" }}</th>
                          </tr>
                          <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.process_labour" :key="index">
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap cursor-pointer">{{ sub_field.process_name ? sub_field.process_name : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_pieces ? sub_field.total_pieces : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_issue_pieces ? sub_field.total_issue_pieces : "-" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_issue_weight ? $h.myFloat(sub_field.total_issue_weight) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.total_receive_weight ? $h.myFloat(sub_field.total_receive_weight) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_weight_loss ? $h.myFloat(sub_field.total_weight_loss) : "0" }}</td>
                            <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_majuri ? $h.myFloat(sub_field.total_majuri) : "0" }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>



            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- END: Data List -->
    <div id="planning-purity-size-charni-planning-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xxl">
            <div class="modal-content">
              <div class="modal-header p-5">
                <div class="flex justify-between items-center w-full">
                  <h2 class="text-lg font-medium mr-auto">Stock List ({{ page_data.final_polish_arr.charni_name ? page_data.final_polish_arr.charni_name : "All" }})</h2>
                  <a data-dismiss="modal" href="javascript:;">
                      <XIcon class="w-8 h-8 text-gray-500" />
                  </a>
                </div>

              </div>
                <div class="modal-body">

                  <div class="border-b border-gray-200 dark:border-dark-5">
                    <div class="">
                      <div class="border">
                        <div class="overflow-x-auto">
                          <div id="responsive-table" class="p-5" v-if="page_data.m_loading">
                            <div class="preview">
                              <div class="overflow-x-auto">
                                <div class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center">
                                  <LoadingIcon icon="bars" class="w-8 h-8" />
                                  <div class="text-center text-xs mt-2">Getting Latest Price</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>

                            <table class="w-full text-center text-xs" v-if="page_data.final_polish_type == 1 || page_data.final_polish_type == 4">
                              <thead>
                                <tr  class="dark:bg-dark-1 bg-dark-1 text-white">
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PACKET NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">STOCK NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">POLISH WT(CT)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">SHAPE</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">COLOR</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PURITY</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">REPO($) </th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">BACK(%) </th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MFG PER/CT($)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">AMOUNT ($)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Repo (INR)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MFG PER/CT(INR)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">AMOUNT (INR)</th>
                                </tr>
                              </thead>
                              <tbody class="text-center">
                                <tr class="bg-gray-200">
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap" colspan="2">Total</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.total_pieces ? $h.myFloat(page_data.final_polish_arr.total_pieces) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.polish_weight ? $h.myFloat(page_data.final_polish_arr.polish_weight) : "0" }} Ct</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_repo ? $h.myFloat(page_data.final_polish_arr.avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_value ? $h.myFloat(page_data.final_polish_arr.avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.total_value ? $h.myFloat(page_data.final_polish_arr.total_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_repo ? $h.myFloat(page_data.final_polish_arr.inr_avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_value ? $h.myFloat(page_data.final_polish_arr.inr_avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_total_value ? $h.myFloat(page_data.final_polish_arr.inr_total_value) : "0" }}</th>
                                </tr>
                                <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.plan_list" :key="index">
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.packet_no ? sub_field.packet_no : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.stock_no ? sub_field.stock_no : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.polish_weight ? $h.myFloat(sub_field.polish_weight) : "0" }} Ct</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.shape_name ? sub_field.shape_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.color_name ? sub_field.color_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.purity_name ? sub_field.purity_name : "-" }}</td>
                                  <!-- <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.rough_weight ? $h.myFloat(sub_field.rough_weight) : "0" }} Ct</td> -->
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.repo_price ? $h.myFloat(sub_field.repo_price) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.discount ? $h.myFloat(sub_field.discount) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.back_price ? $h.myFloat(sub_field.back_price) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value ? $h.myFloat(sub_field.total_value) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.repo_price_inr ? $h.myFloat(sub_field.repo_price_inr) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.back_price_inr ? $h.myFloat(sub_field.back_price_inr) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value_inr ? $h.myFloat(sub_field.total_value_inr) : "0" }}</td>
                                </tr>
                                <tr class="dark:bg-dark-1 bg-dark-1 text-white">
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap" colspan="2">Total</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.total_pieces ? $h.myFloat(page_data.final_polish_arr.total_pieces) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.polish_weight ? $h.myFloat(page_data.final_polish_arr.polish_weight) : "0" }} Ct</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_repo ? $h.myFloat(page_data.final_polish_arr.avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_value ? $h.myFloat(page_data.final_polish_arr.avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.total_value ? $h.myFloat(page_data.final_polish_arr.total_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_repo ? $h.myFloat(page_data.final_polish_arr.inr_avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_value ? $h.myFloat(page_data.final_polish_arr.inr_avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_total_value ? $h.myFloat(page_data.final_polish_arr.inr_total_value) : "0" }}</th>
                                </tr>
                              </tbody>
                            </table>
                            <table class="w-full text-center text-xs" v-if="page_data.final_polish_type == 2">
                              <thead>
                                <tr  class="dark:bg-dark-1 bg-dark-1 text-white">
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PACKET NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">STOCK NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MANAGER</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PROCESS</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">EMPLOYEE</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">POLISH WT(CT)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">SHAPE</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">COLOR</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PURITY</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">REPO($) </th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">BACK(%) </th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MFG PER/CT($)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">AMOUNT ($)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">Repo (INR)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MFG PER/CT(INR)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">AMOUNT (INR)</th>
                                </tr>
                              </thead>
                              <tbody class="text-center">
                                <tr class="bg-gray-200">
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap" colspan="2">Total</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.total_pieces ? $h.myFloat(page_data.final_polish_arr.total_pieces) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.polish_weight ? $h.myFloat(page_data.final_polish_arr.polish_weight) : "0" }} Ct</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_repo ? $h.myFloat(page_data.final_polish_arr.avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_value ? $h.myFloat(page_data.final_polish_arr.avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.total_value ? $h.myFloat(page_data.final_polish_arr.total_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_repo ? $h.myFloat(page_data.final_polish_arr.inr_avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_value ? $h.myFloat(page_data.final_polish_arr.inr_avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_total_value ? $h.myFloat(page_data.final_polish_arr.inr_total_value) : "0" }}</th>
                                </tr>
                                <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.plan_list" :key="index">
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.packet_no ? sub_field.packet_no : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.stock_no ? sub_field.stock_no : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.manager_short_code ? sub_field.manager_short_code : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.process_name ? sub_field.process_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ ([3,4].includes(sub_field.process_type) ? sub_field.planner_short_code : (sub_field.external == 1 ? sub_field.jober_short_code : (sub_field.employee_short_code ? sub_field.employee_short_code : '-'))) }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.polish_weight ? $h.myFloat(sub_field.polish_weight) : "0" }} Ct</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.shape_name ? sub_field.shape_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.color_name ? sub_field.color_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.purity_name ? sub_field.purity_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.repo_price ? $h.myFloat(sub_field.repo_price) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.discount ? $h.myFloat(sub_field.discount) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.back_price ? $h.myFloat(sub_field.back_price) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value ? $h.myFloat(sub_field.total_value) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.repo_price_inr ? $h.myFloat(sub_field.repo_price_inr) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.back_price_inr ? $h.myFloat(sub_field.back_price_inr) : "0" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ sub_field.total_value_inr ? $h.myFloat(sub_field.total_value_inr) : "0" }}</td>
                                </tr>
                                <tr class="dark:bg-dark-1 bg-dark-1 text-white">
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap" colspan="2">Total</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.total_pieces ? $h.myFloat(page_data.final_polish_arr.total_pieces) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.polish_weight ? $h.myFloat(page_data.final_polish_arr.polish_weight) : "0" }} Ct</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_repo ? $h.myFloat(page_data.final_polish_arr.avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.avg_value ? $h.myFloat(page_data.final_polish_arr.avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.total_value ? $h.myFloat(page_data.final_polish_arr.total_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_repo ? $h.myFloat(page_data.final_polish_arr.inr_avg_repo) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_avg_value ? $h.myFloat(page_data.final_polish_arr.inr_avg_value) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.inr_total_value ? $h.myFloat(page_data.final_polish_arr.inr_total_value) : "0" }}</th>
                                </tr>
                              </tbody>
                            </table>
                            <table class="w-full text-center text-xs" v-if="page_data.final_polish_type == 3">
                              <thead>
                                <tr  class="dark:bg-dark-1 bg-dark-1 text-white">
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PACKET NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">STOCK NO</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">ROUGH WT(CT)</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">CR WEIGHT</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">MANAGER</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">PROCESS</th>
                                  <th class="border-b whitespace-nowrap border-r py-2 px-2 dark:border-dark-5">EMPLOYEE</th>
                                </tr>
                              </thead>
                              <tbody class="text-center">
                                <tr class="bg-gray-200">
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap" colspan="2">Total</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.total_pieces ? $h.myFloat(page_data.final_polish_arr.total_pieces) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.rough_weight ? $h.myFloat(page_data.final_polish_arr.rough_weight) : "0" }} Ct</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                </tr>
                                <tr class="hover:bg-gray-200 border-2 border-b-0" v-for="(sub_field, index) in page_data.plan_list" :key="index">
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ index + 1 }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.packet_no ? sub_field.packet_no : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.stock_no ? sub_field.stock_no : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.weight ? $h.myFloat(sub_field.weight) : "0" }} Ct</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.cr_weight ? $h.myFloat(sub_field.cr_weight) : "0" }} Ct</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.manager_short_code ? sub_field.manager_short_code : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ sub_field.process_name ? sub_field.process_name : "-" }}</td>
                                  <td class="border-b border-r py-2 px-2 whitespace-nowrap">{{ ([3,4].includes(sub_field.process_type) ? sub_field.planner_short_code : (sub_field.external == 1 ? sub_field.jober_short_code : (sub_field.employee_short_code ? sub_field.employee_short_code : '-'))) }}</td>
                                </tr>
                                <tr class="dark:bg-dark-1 bg-dark-1 text-white">
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap" colspan="2">Total</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap text-right">{{ page_data.final_polish_arr.total_pieces ? $h.myFloat(page_data.final_polish_arr.total_pieces) : "0" }}</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap">{{ page_data.final_polish_arr.rough_weight ? $h.myFloat(page_data.final_polish_arr.rough_weight) : "0" }} Ct</th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                  <th class="border-b border-r py-2 px-2 whitespace-nowrap"></th>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BEGIN: DATA List -->
  </div>
</template>

<script>
import { computed, defineComponent, inject, onMounted, reactive, ref, toRefs } from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { BASE_URL } from '@/constants/config.js'
import axios from 'axios'
import { helper as $h } from '@/utils/helper'
import store from '@/store';
import FileDownload from "js-file-download";

export default defineComponent({
  setup() {

    // const user_details = computed(() => store.state.user.currentUser)
    // const route = useRoute()
    const swal = inject('$swal')

    const page_data = reactive({
      "r_loading": false,
      "m_loading": false,
      "generate": "no",
      "kapan_id": '0',
      "costing_per_ct": "",
      "lot_items": [],
      "kapan_details": [],
      "planning_polish_pending": [],
      "rough_polish_pending": [],
      "final_polish_pending": [],
      "final_polish_done": [],
      "planning_polish_pending_total": [],
      "rough_polish_pending_total": [],
      "final_polish_pending_total": [],
      "final_polish_done_total": [],
      "process_labour": [],
      "total_majuri": 0,
      "total_loss": 0,
      "conversation_rate": 0,
      "rough_total_pieces": 0,
      "rough_total_weight": 0,
      "rough_avg_weight": 0,
      "pending_total_pieces": 0,
      "pending_total_weight": 0,
      "pending_avg_weight": 0,
      "plan_polish_weight": 0,
      "plan_rough_weight": 0,
      "plan_total_pieces": 0,
      "plan_polish_per": 0,
      "plan_18_up_polish_per": 0,
      "shape_group_arr": [],
      "shape_plans": [],
      "manual_charni_arr": [],
      "manual_charni": [],
      "purity_list": [],
      "plan_list": [],
      "pending_packets_arr": [],
      "size_id": null,
      "size_name": null,
      "size_arr": [],
      "purity_arr": [],
      "shape_group": null,
      "final_polish_arr": [],
      "final_polish_type": "0"

    })

    const getReportDetails = () => {

      if(page_data.kapan_id == '0') {

      } else {

        const params = {
          kapan_id: page_data.kapan_id
        };

        page_data.r_loading = true

        let promise = axios({
          url: "api/report/rfp-index",
          method: "POST",
          data: params,
          baseURL: BASE_URL,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),

          },
          config: {
            headers: {
              Accept: "application/json"
            }
          }
        });
        return promise
          .then(result => result.data)
          .then(data => {

            page_data.r_loading = false

            if (data.status == "success") {

              page_data.planning_polish_pending = data.planning_polish_pending
              page_data.rough_polish_pending = data.rough_polish_pending
              page_data.final_polish_pending = data.final_polish_pending
              page_data.final_polish_done = data.final_polish_done
              page_data.planning_polish_pending_total = data.planning_polish_pending_total
              page_data.rough_polish_pending_total = data.rough_polish_pending_total
              page_data.final_polish_pending_total = data.final_polish_pending_total
              page_data.final_polish_done_total = data.final_polish_done_total
              page_data.process_labour = data.process_labour
              page_data.kapan_details = data.packet_item.kapan_details
              page_data.total_majuri = data.packet_item.total_majuri
              page_data.total_loss = data.packet_item.total_loss
              page_data.conversation_rate = data.packet_item.conversation_rate
              page_data.rough_total_pieces = data.packet_item.rough_total_pieces
              page_data.rough_total_weight = data.packet_item.rough_total_weight
              page_data.rough_avg_weight = data.packet_item.rough_avg_weight
              page_data.plan_polish_weight = data.packet_item.plan_polish_weight
              page_data.plan_rough_weight = data.packet_item.plan_rough_weight
              page_data.plan_total_pieces = data.packet_item.plan_total_pieces
              page_data.plan_polish_per = data.packet_item.plan_polish_per

              page_data.generate = 'gen';
            } else {
              swal("Warning !", data.message, "warning")
            }


          })
          .catch(_error => {
            page_data.r_loading = false
            swal("Error !", "Something went wrong", "error")
          });
      }


    }

    const getLotDetails = async () => {
      let params = {
      }
      let api_url = 'api/master/dp_lot_all_details'

      let promise = axios({
        url: api_url,
        method: "post",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.kapan_id = '0'
          page_data.lot_items = data.items
        })
        .catch(_error => {
          page_data.kapan_id = '0'
          page_data.lot_items = []
        });
    }

    const get_purity_charni_list = (items, shape) => {
      const params = {
        kapan_id: page_data.kapan_id,
        conversation_rate: window.btoa(page_data.conversation_rate),
        size_id: window.btoa(items.id),
        shape_group: window.btoa(shape),
        plan_polish_weight: window.btoa(page_data.plan_polish_weight)
      };

      let promise = axios({
        url: "api/report/rpp-pwbs",
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.purity_list = data.items;
          page_data.size_id = items.id;
          page_data.size_name = items.size_name;
          page_data.shape_group = shape;
          page_data.size_arr = items;
          cash('#purity-size-charni-planning-modal').modal('show')

        })
        .catch(_error => {
        });
    }
    const get_plan_list = (items, type) => {
      const params = {
        kapan_id: window.btoa(page_data.kapan_id),
        type: window.btoa(type),
        conversation_rate: window.btoa(page_data.conversation_rate),
        size_id: window.btoa(items.id)
      };

      page_data.m_loading = true

      cash('#planning-purity-size-charni-planning-modal').modal('show')
      let promise = axios({
        url: "api/report/rfp-sws",
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {
          page_data.plan_list = data.items;
          page_data.final_polish_arr = items;
          page_data.final_polish_type = type;
          page_data.m_loading = false

        })
        .catch(_error => {
          page_data.m_loading = false
        });
    }
    const get_pending_packets = () => {
      const params = {
        kapan_id: page_data.kapan_id
      };

      let promise = axios({
        url: "api/report/rpp-fppp",
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
      .then(result => result.data)
      .then(data => {
        page_data.pending_packets_arr = data.items;
        cash('#pending-packets-modal').modal('show')

        })
        .catch(_error => {
          page_data.pending_packets_arr = [];
        });
    }

    const updateInrRates = () => {

      if(page_data.conversation_rate > 0) {

        page_data.conversation_rate = parseFloat(page_data.conversation_rate)
      } else {
        page_data.conversation_rate = 0
      }

      page_data.planning_polish_pending.forEach(sub_element => {
        sub_element.inr_avg_repo = parseFloat(sub_element.avg_repo * page_data.conversation_rate).toFixed(0)
        sub_element.inr_avg_value = parseFloat(sub_element.avg_value * page_data.conversation_rate).toFixed(0)
        sub_element.inr_total_value = parseFloat(sub_element.total_value * page_data.conversation_rate).toFixed(0)
      });
      page_data.final_polish_pending.forEach(sub_element => {
        sub_element.inr_avg_repo = parseFloat(sub_element.avg_repo * page_data.conversation_rate).toFixed(0)
        sub_element.inr_avg_value = parseFloat(sub_element.avg_value * page_data.conversation_rate).toFixed(0)
        sub_element.inr_total_value = parseFloat(sub_element.total_value * page_data.conversation_rate).toFixed(0)
      });
      page_data.final_polish_done.forEach(sub_element => {
        sub_element.inr_avg_repo = parseFloat(sub_element.avg_repo * page_data.conversation_rate).toFixed(0)
        sub_element.inr_avg_value = parseFloat(sub_element.avg_value * page_data.conversation_rate).toFixed(0)
        sub_element.inr_total_value = parseFloat(sub_element.total_value * page_data.conversation_rate).toFixed(0)
      });
      page_data.planning_polish_pending_total.inr_avg_repo = parseFloat(page_data.planning_polish_pending_total.avg_repo * page_data.conversation_rate).toFixed(0)
      page_data.planning_polish_pending_total.inr_avg_value = parseFloat(page_data.planning_polish_pending_total.avg_value * page_data.conversation_rate).toFixed(0)
      page_data.planning_polish_pending_total.inr_total_value = parseFloat(page_data.planning_polish_pending_total.total_value * page_data.conversation_rate).toFixed(0)
      page_data.final_polish_pending_total.inr_avg_repo = parseFloat(page_data.final_polish_pending_total.avg_repo * page_data.conversation_rate).toFixed(0)
      page_data.final_polish_pending_total.inr_avg_value = parseFloat(page_data.final_polish_pending_total.avg_value * page_data.conversation_rate).toFixed(0)
      page_data.final_polish_pending_total.inr_total_value = parseFloat(page_data.final_polish_pending_total.total_value * page_data.conversation_rate).toFixed(0)
      page_data.final_polish_done_total.inr_avg_repo = parseFloat(page_data.final_polish_done_total.avg_repo * page_data.conversation_rate).toFixed(0)
      page_data.final_polish_done_total.inr_avg_value = parseFloat(page_data.final_polish_done_total.avg_value * page_data.conversation_rate).toFixed(0)
      page_data.final_polish_done_total.inr_total_value = parseFloat(page_data.final_polish_done_total.total_value * page_data.conversation_rate).toFixed(0)

      // Update Rates
    }

    const exportReportDetails = () =>{

      const today = new Date();
      const date = today.getDate() + '' + (today.getMonth() + 1) + '' + today.getFullYear();
      // const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date;
      let filename = "KODLLIN_" +dateTime + ".xlsx";

      let promise = axios({
          url: "/api/report/rfp-export",
          method: "post",
          data: {
            kapan_id: page_data.kapan_id,
            conversation_rate: window.btoa(page_data.conversation_rate),
          },
          baseURL: BASE_URL,
          headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),

          },
          config: {
              headers: {
                  Accept: "application/json"
              }
          },
          responseType: "blob",
      });

      return promise
          .then((result) => result.data)
          .then((data) => {
              FileDownload(data, filename);
          })
          .catch((_error) => {
              return [];
          });
      }

    onMounted(() => {
      getLotDetails()
    })
    return {
      page_data,
      getReportDetails,
      updateInrRates,
      get_purity_charni_list,
      get_plan_list,
      get_pending_packets,
      exportReportDetails
    }
  }

})
</script>
